(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[96209],{

/***/ 50389:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cookies-policy",
      function () {
        return __webpack_require__(23540);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 23540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var UI_views_TechnicalPage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59523);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96076);



var CookiesPolicy = function(param) {
    var introSection = param.introSection;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_views_TechnicalPage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        introSection: introSection,
        type: utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .PAGES.cookiesPolicy */ .q5.cookiesPolicy,
        title: utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ROUTES.cookiesPolicy.title */ .y2.cookiesPolicy.title
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (CookiesPolicy);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [25675,74129,24168,57330,13107,39370,49774,92888,40179], function() { return __webpack_exec__(50389); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);